import React, { useContext, useState } from 'react'
import { CardContext } from '../../store/CardContext';

function LiveUpdates() {

    const [cardData] = useContext(CardContext)
    // console.log(cardData, 'cardData');
    const {
        logo,
        liveUpdates,
        colors,
    } = cardData

    const [readMore, setReadMore] = useState(false);
    const handleReadMore = () => {
        setReadMore(!readMore);
    };

    const [activeTab, setActiveTab] = useState('tab3')
    const showTab = (tabId) => {
        // console.log(tabId);
        setActiveTab(tabId)
    }

    const txtColor = colors?.txtColor ? colors?.txtColor : "black"
    const btnColor = colors?.btnColor ? colors?.btnColor : "black"
    const youtubeUrls = liveUpdates?.liveMedia.find((item) => item.platform === "youtube")
    return (
        <div>
            <div>
                <div className="live_update " style={{ color: txtColor }}>
                    <div className="live_header w-full flex mx-auto py-5 justify-between items-center flex-shrink-0  shadow-md ">
                        <div className="live_header_logo flex justify-between items-center gap-2.5 mx-3">
                            <img className='w-10 h-10' src={logo} />
                            <p
                                className="text-center  text-base font-semibold"
                                id="l-update"
                            >
                                Live Updates
                            </p>
                        </div>
                        {/* <div className="language-picker js-language-picker mr-5 flex items-center">
                            <form
                                action=""
                                className="language-picker__form"
                            >
                                <select
                                    className="language-picker-select-border rounded-md border border-orange-500 text-xs font-medium px-2 py-1 flex items-center"
                                    id="language-picker-select"
                                    name="language-picker-select"
                                    onchange="changeLanguage()"
                                >
                                    <option
                                        lang="de"
                                        value="hi"
                                    >
                                        Hindi
                                    </option>
                                    <option
                                        lang="en"
                                        selected
                                        value="en"
                                    >
                                        English
                                    </option>
                                </select>
                            </form>
                        </div> */}
                    </div>
                    <div className="Latest_update px-4">
                        <p
                            className=" text-base font-semibold mt-8 mb-4 "
                            id="l-latest-head"
                        >
                            {liveUpdates?.heading}
                        </p>
                        <div className="Latest_update_details">
                            <div className="p-4">
                                <p
                                    className=" font-semibold text-sm"
                                    id="l-latest-head1"
                                >
                                    {liveUpdates?.tittle}
                                </p>
                                <div className="mt-2">
                                    <div className='flex'>
                                        <p className={` font-normal text-xs ${readMore ? 'line-clamp-none' : 'line-clamp-5 '} overflow-hidden`} id="l-latest-dtl">
                                            {liveUpdates?.description}
                                        </p>
                                        {/* {readMore ?
                                            ""
                                            :
                                            <p className='flex items-end' >...</p>
                                        } */}
                                    </div>
                                    <p className="text-xs text-end text-blue-500 cursor-pointer mt-1" onClick={handleReadMore} style={{ color: btnColor }}>
                                        {readMore ? "Read Less" : "Read More"}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="flex items-center justify-center mb-5 px-2">
                        <div className="tab-container flex justify-around gap-1   w-full  mt-5">
                            {/* <div
                                className={`tab  border-2 text-center p-2 w-full `}
                                id="tab1button"
                                style={{
                                    borderColor: activeTab === 'tab1' ? txtColor : btnColor,
                                    color: activeTab === 'tab1' ? txtColor : btnColor
                                }}
                                onClick={(e) => showTab('tab1')}
                            >
                                X
                            </div>
                            <div
                                className={`tabone  border-2  text-center p-2 w-full `}
                                id="tab2button"
                                style={{
                                    borderColor: activeTab === 'tab2' ? txtColor : btnColor,
                                    color: activeTab === 'tab2' ? txtColor : btnColor
                                }}
                                onClick={(e) => showTab('tab2')}
                            >
                                Facebook
                            </div> */}
                            <div
                                className={`tabone  border-2 text-center p-2 w-full `}
                                id="tab2button"
                                style={{
                                    borderColor: activeTab === 'tab3' ? txtColor : btnColor,
                                    color: activeTab === 'tab3' ? txtColor : btnColor
                                }}
                                onClick={(e) => showTab('tab3')}
                            >
                                Youtube
                            </div>
                        </div>
                    </div>

                    {/* {activeTab === "tab2" &&
                        <div
                            className=" scialmedia px-2"
                            id="facebook"
                        
                        >
                            <div className="live_details mb-2">
                                <div className="youtube_update">
                                    <div className="mb-4">
                                        <iframe
                                            src="https://www.facebook.com/plugins/post.php?href=https://www.facebook.com/share/p/3DVVi8pVhaULufQx/?mibextid=oFDknk&width=500"
                                            width="100%"
                                            height="200"
                                            style={{ border: 'none', overflow: 'hidden' }}
                                            scrolling="no"
                                            frameBorder="0"
                                            allowFullScreen={true}
                                            allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
                                        ></iframe>
                                        <iframe
                                            src="https://www.facebook.com/plugins/post.php?href=https%3A%2F%2Fwww.facebook.com%2F20531316728%2Fposts%2F10154009990506729%2F&width=500&show_text=true&height=202&appId"
                                            width="100%"
                                            height="200"
                                            style={{ border: 'none', overflow: 'hidden' }}
                                            scrolling="no"
                                            frameBorder="0"
                                            allowFullScreen={true}
                                            allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
                                        ></iframe>


                                    </div>
                                </div>
                            </div>

                        </div>
                    } */}

                    {activeTab === "tab3" &&
                        <div
                            className=" scialmedia px-2"
                            id="Youtube"

                        >
                            {youtubeUrls?.urls.map((obj) => (

                                <div className="live_details mb-2">
                                    <div className="youtube_update">
                                        <iframe
                                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                            allowFullScreen
                                            frameBorder="0"
                                            height="200"
                                            src={obj}
                                            title="YouTube video player"
                                            width="100%"
                                        />
                                    </div>
                                </div>
                            ))}
                        </div>
                    }
                </div>
            </div>
        </div>
    )
}

export default LiveUpdates